import { Button, Stack } from "@mui/material"
import { useTranslation } from "react-i18next"

import type { InstallationType } from "types/device.types"

import FormButtons from "widgets/common/FormButtons"

interface InstallationFormActionsProps {
  installationType: InstallationType
  isLoading: boolean
  disabled?: boolean
  onClose: () => void
  onUninstall: () => void
}

const InstallationFormActions = ({
  installationType,
  isLoading,
  disabled,
  onClose,
  onUninstall,
}: InstallationFormActionsProps) => {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      mt={2}
    >
      <Button
        type="button"
        variant="outlined"
        color="error"
        onClick={onUninstall}
        disabled={installationType === "uninstalled" || isLoading}
      >
        {t("device_installation.UNINSTALL")}
      </Button>
      <FormButtons
        onClose={onClose}
        buttonText={"generic.UPDATE"}
        isLoading={isLoading}
        disabled={disabled}
      />
    </Stack>
  )
}

export default InstallationFormActions
